window.addEventListener('load', function () {

    $('#show_internal_links').on('click', function () {
        var btn = $(this);
        var list = $('#internal_list').closest('.result_block');
        if (list.is(':visible')) {
            btn.removeClass('fa-chevron-up');
            btn.addClass('fa-chevron-down');
            list.hide('fast');
        }
        else {
            btn.addClass('fa-chevron-up');
            btn.removeClass('fa-chevron-down');
            list.show('fast');
        }
    });

    var clear_input = $('#clear_input');
    var url_input = $('#url');
    var run_scanning_input = $('#run_scanning');

    url_input.on('input', function (){
        if ($(this).val() !== '' && window.location.search.indexOf('public_id=') < 0) {
            clear_input.removeClass('d-none');
        }
        else {
            clear_input.addClass('d-none');
        }
    }).trigger('input');

    clear_input.on('click', function (){
        url_input.val('').trigger('input');
    });

    $(document).on('click','#scanning_button',function() {
        run_scanning_input.removeClass('hidden');
        var form_scan = $('#scanning_button').closest('form');
        form_scan.find('input[type=hidden]').remove();
        form_scan.submit();
    });

    if (typeof run_scanning != "undefined" && run_scanning) {
        var web_scanner = new WebScanner();
    }

    if (typeof WebScanner !== 'undefined') {
        var originalDrawMalwareScan = WebScanner.prototype.drawMalwareScan;

        WebScanner.prototype.drawMalwareScan = function() {
            originalDrawMalwareScan.apply(this, arguments);

            setTimeout(function() {
                checkMalwareBlockOverflow();
            }, 100);
        };
    }
});

function checkMalwareBlockOverflow() {
    var resultBlocks = document.querySelectorAll('#result_list .result_block');

    for (var i = 0; i < resultBlocks.length; i++) {
        var block = resultBlocks[i];
        if (block.scrollHeight > block.clientHeight) {
            block.classList.add('has-overflow');
        } else {
            block.classList.remove('has-overflow');
        }
    }
}
window.addEventListener('resize', checkMalwareBlockOverflow);

var LinkScanner = function () {

    var $this = this;

    $this.is_runinng = false;

    $this.public_id = '';

    $this.links = [];

    $this.loaded_process = 0;

    $this.on_change_progress = undefined;

    $this.init = function (public_id) {
        if (typeof public_id != "undefined") {
            $this.public_id = public_id;
        }
        if (!$this.is_runinng) {
            $this.is_runinng = true;
            $("div.non_indexable_detail").hover(
                function () {
                    $(this).find('div.noindexable_block').removeClass('d-none');
                },
                function (){
                    $(this).find('div.noindexable_block').addClass('d-none');
                });
            $('#internal_list .internal_link').each(function (item) {
                var loaded = !!$(this).data('done');
                $this.links.push({
                    href: $(this).data('href'),
                    detail: $(this).next('div.non_indexable_detail'),
                    loaded: loaded,
                    loading: false,
                });
            });

        }
    }


    $this.checkLinks = function () {
        $this.onLinkCheck();
        $this.links.forEach(function (link){
            if ($this.loaded_process < 3 && !link.loaded && !link.loading) {
                $this.loaded_process++;
                link.loading = true;
                var sent_data = new FormData();
                if ($this.public_id !== '') {
                    sent_data.append('public_id', $this.public_id);
                }
                sent_data.append('action', 'check_link_noindex');
                sent_data.append('link', link.href);
                sent_data.append('public_result', $('#public_result').is(':checked') ? 'on' : 'off');
                $.ajax({
                    url: window.location.pathname,
                    type: 'POST',
                    processData: false,
                    contentType: false,
                    data: sent_data,
                    beforeSend: function () {
                        link.detail.prepend('<span class="loading"><img src="/assets/img/cleantalk-logo-animated.svg" class="loader_cleantalk"></span>');
                    },
                    success: function (data) {
                        $this.endRequest(link);
                        try {
                            data = JSON.parse(data);
                            if (typeof data.code != "undefined") {
                                link.detail.prepend('<span>' + data.code + '</span> ');
                            }
                            if (typeof data.noindex != "undefined" && data.noindex) {
                                $this.addNoindex(link.detail);
                            }
                        }
                        catch (e) {
                            console.log(e);
                        }
                    },
                    error: function (data) {
                        $this.endRequest(link);
                        console.log(data);
                    },
                });
            }
        });
    }

    $this.endRequest = function (link) {
        $this.loaded_process--;
        link.detail.find('span.loading').remove();
        link.loaded = true;
        $this.checkLinks();
    }

    $this.addNoindex = function (detail) {
        var has_block = false
        if (detail.children('div.noindexable_block').length > 0) has_block = true;
        if (!has_block) {
            detail.append(
                '(non-indexable)\n' +
                '<div class="hidden noindexable_block"></div>'
            );
        }
        detail.children('div.noindexable_block').append(
            '<div>\n' +
            'Page have "noindex"\n' +
            '</div>');
    }

    $this.checkProgress = function () {
        var total = 0;
        var finished = 0;
        var loading_progress = 100;
        $this.links.forEach(function (link){
            total ++;
            if (link.loaded) finished++;
        });
        if (total !== finished) loading_progress = Math.ceil((total > 0 ) ? (finished / total * 100) : 100);
        return loading_progress;
    }

    $this.onLinkCheck = function () {
        if (typeof $this.on_change_progress == "function") {
            $this.on_change_progress($this.checkProgress());
        }
    }

};

var WebScanner = function () {
    var $this = this;

    $this.public_id = (typeof public_id == "string") ? public_id : '';

    $this.url = false;

    $this.page = {
        title: $('#page_title'),
        page_info_block: $('#page_info'),
        public_safe_lists: $('#public_safe_lists'),
        ssl_info_block: $('#ssl_info'),
        scanner_report: $('#scanner_report'),
        malware_list: $('#result_list'),
        malware_list_title: $('#malware-details'),
        malware_list_count: $('#malware_count'),
        result_links: $('#result_links'),
        external_links_title: $('#external-links'),
        external_links_count: $('#external_count'),
        internal_links_title: $('#internal-links'),
        internal_links_count: $('#internal_count'),
        result_repository: $('#result_repository'),
        result_recognize_cms: $('#result_recognize_cms'),
        progressbar: $('#progressbar'),
        input: $('#url'),
        scanning_button: $('#scanning_button'),
        run_scanning_title: $('#run_scanning'),
    };

    $this.malware_title = {
        dbd: 'Drive by download',
        signatures: 'Signatures',
        redirects: 'Redirects'
    }

    $this.register_form = {
        title: $('form#reg h2'),
        button: $('#reg-sub')
    }

    $this.scanningTimer = 0;
    $this.scanningIteration = 0;

    $this.link_scanner = new LinkScanner();
    $this.link_scanner_progress = 0;

    $this.scanner_steps = {};

    $this.init = function () {
        if ($this.page.input.length > 0 && $this.page.input.val().trim() !== '') {
            $this.url = $this.page.input.val().trim().replace(/\/+$/, '');
        }
        $this.scanningTimer = setInterval($this.ProcessScanningTitle, 500);
        $this.formatLink();
        $this.nextStep();
        $this.link_scanner.on_change_progress = function (link_percent) {
            $this.link_scanner_progress = link_percent;
            $this.checkProgress();
            $this.setCurrentStep();
            if (link_percent >= 100) {
                $this.setEndLinkCheck();
                $('.scanning_step[data-step="scan_internal_links"]').find('span.step_percent').html('(100%)');
            }
        }

        $this.page.input.on('input', function (){
            if ($(this).val() !== $this.url) {
                $this.page.scanning_button.html(lang.l_scan);
            }
            else {
                $this.page.scanning_button.html(lang.l_rescan);
            }
        }).trigger('input');
    }

    $this.formatLink = function () {
        if ($this.public_id !== '') {
            var params = window.location.search
                .replace('?','').split('&').reduce(function(p,e){
                    var a = e.split('=');
                    p[ decodeURIComponent(a[0])] = decodeURIComponent(a[1]);
                    return p;
                }, {});
            if (typeof params['public_id'] == "undefined") {
                window.history.pushState(null, null,
                    location.href + ((window.location.search !== '') ? '&' : '?') + 'public_id=' + $this.public_id
                );
            }
            else if (params['public_id'] !== $this.public_id) {
                params['public_id'] = $this.public_id;
                var query = [];
                $.each(params, function (key, value) {
                    query.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
                });
                window.history.pushState(null, null, window.location.pathname + '?' + query.join('&'));
            }
        }
    }

    $this.nextStep = function () {
        var sent_data = new FormData();
        sent_data.append('action', 'next_scanning_step');
        sent_data.append('public_id', $this.public_id);
        sent_data.append('public_result', $('#public_result').is(':checked') ? 'on' : 'off');
        $.ajax({
            url: window.location.pathname,
            type: 'POST',
            processData: false,
            contentType: false,
            data: sent_data,
            beforeSend: function () {
                $this.setCurrentStep();
            },
            success: function (data) {
                try {
                    data = JSON.parse(data);
                    $this.finishStep(data);
                    $this.page.run_scanning_title.removeClass('hidden');
                }
                catch (e) {
                    console.log(e);
                }
            },
            error: function (data) {
                console.log(data);
            },
        });
    }

    $this.finishStep = function (data) {
        if (typeof data != "undefined") {
            $this.scanning_result = data;
        }
        if (typeof data.error != "undefined") {
            console.log(data.error);
        }
        if (typeof data.end_scanning != "undefined" && !data.end_scanning) {
            $this.nextStep();
        }
        else {
            $this.setCurrentStep();
            if (!!$('#scanner-banner')[0]) {
                $('#scanner-banner').removeClass('d-none');
                $('#main_footer').css('padding-bottom', '70px');
                $('#banner-message').html(data.message_banner);
            }
            if (!$this.page.internal_links_title.hasClass('d-none')) {
                $('.scanning_step[data-step="scan_internal_links"]').find('span.step_percent').html('(100%)');
            }
        }
        $this.drawResult();
    }

    $this.ProcessScanningTitle = function () {
        $this.scanningIteration++;
        if ($this.scanningIteration > 3) $this.scanningIteration = 0;
        var dots = '';
        for (var i = 0; i < $this.scanningIteration; i++) {
            dots += '.';
        }
        $this.page.title.find('.scanning_process').html(
            lang.l_scanning + dots
        );
    }

    $this.ScanDone = function () {
        clearInterval($this.scanningTimer);
        $this.page.title.find('.scanning_process').html('').addClass('d-none');
        $this.page.progressbar.addClass('d-none');
        $('.scanning_step').removeClass('current_step');
    }

    $this.drawResult = function () {

        $this.drawPageInfo();
        $this.drawSSLResult();
        $this.drawPublicSafeListsResult();
        $this.drawJSIframes();
        $this.drawMalwareScan();
        $this.drawRepositoryScan();
        $this.drawCMSRecognize();
        $this.checkProgress();
        $this.formatStepLink();

        $this.formatRegisterForm();

        var anchor_links = $('a[href^="#"]');
        anchor_links.each(function (index, element) {
            var id = $(element).attr('href').replace('#', '');
            if (id !== '') {
                $('#' + id).addClass('anchor_target');
            }
        });

    }

    $this.drawTitle = function () {
        if (typeof $this.scanning_result.title == "object" &&
            typeof $this.scanning_result.title.message == "string" &&
            $this.scanning_result.title.message !== '' &&
            typeof $this.scanning_result.title.style == "string" &&
            $this.page.title.find('.scanning_result').html() === '') {
            $this.page.title.find('.scanning_result').html($this.scanning_result.title.message);
            $this.page.title.find('.scanning_result').addClass('text-' + $this.scanning_result.title.style);
        }
    }

    $this.drawPageInfo = function () {
        if ($this.page.page_info_block.find('.result_block').html().trim() === '') {
            var message = '';
            message = '<ul>';
            if (typeof $this.scanning_result.get_url_code == "object" &&
                $this.scanning_result.get_url_code.process &&
                typeof $this.scanning_result.get_url_code.result == "object") {

                if (typeof $this.scanning_result.get_url_code.result.error == "undefined") {
                    message += '<li>' + lang.l_http_response + ' ' + $this.scanning_result.get_url_code.result.response_code;
                }
                else {
                    message += '<li class="warning">' + $this.scanning_result.get_url_code.result.error;
                }
                message += '</li>';

                if (typeof $this.scanning_result.get_url_code.result.url_ip == "string") {
                    message += '<li>IP: ' + $this.scanning_result.get_url_code.result.url_ip + '</li>';
                }

                if (typeof $this.scanning_result.get_url_code.result.ip_hostname == "string") {
                    message += '<li>Hostname IP: ' + $this.scanning_result.get_url_code.result.ip_hostname + '</li>';
                }

                if (typeof $this.scanning_result.get_url_code.result.server == "string") {
                    message += '<li>Server: ' + $this.scanning_result.get_url_code.result.server + '</li>';
                }

                if (typeof $this.scanning_result.get_url_code.result.redirects == "object" &&
                    $this.scanning_result.get_url_code.result.redirects.length > 1) {
                    var li_class = ($this.scanning_result.get_url_code.result.redirects.length > 2) ? 'warning' : '';
                    message += '<li class="' + li_class + '">Redirects';
                    if ($this.scanning_result.get_url_code.result.redirects.length > 2) {
                        message += ' (Warning, more than 2 redirects)';
                    }
                    message += ': ';
                    message += '<ul>';
                    $this.scanning_result.get_url_code.result.redirects.forEach(function (item) {
                        message += '<li class="' + li_class + '">' + item.location + ': ' + item.code + '</li>';
                    });
                    message += '</ul>';
                    message += '</li>';
                }
            }
            else {
                message += '<li>' + lang.l_no_info + '</li>';
            }
            message += '</ul>';
            $this.page.page_info_block.find('.result_block').html(message);
            $this.page.page_info_block.removeClass('d-none');
            $this.page.scanner_report.removeClass('d-none');
        }
        if ($this.page.page_info_block.find('.page_size').length === 0 &&
            typeof $this.scanning_result.malware_scan == "object" &&
            typeof $this.scanning_result.malware_scan.result == "object" &&
            typeof $this.scanning_result.malware_scan.result.page == "object" &&
            typeof $this.scanning_result.malware_scan.result.page.content_size == "string"
        ) {
            $($this.page.page_info_block.find('.result_block').find('ul')[0]).append(
                '<li class="page_size">' +
                lang.l_page_size.replace('%s', $this.scanning_result.malware_scan.result.page.content_size) +
                '</li>'
            );
        }
    }

    $this.drawMalwareScan = function () {
        if (typeof $this.scanning_result.malware_scan == "object" &&
            $this.scanning_result.malware_scan.process &&
            typeof $this.scanning_result.malware_scan.result == "object") {
            var malware_scan = $this.scanning_result.malware_scan.result;

            var total = 0;
            var block = '';

            if (typeof malware_scan.result_list == "object" &&
                $('#result_list div.result_block').length === 0) {
                total = 0;
                if (!$.isEmptyObject(malware_scan.result_list)) {
                    for (type in malware_scan.result_list) {
                        block += '<div class="result_block">' +
                            '<div class="block_title">';
                        if (typeof $this.malware_title[type] != "undefined") {
                            block += $this.malware_title[type];
                        } else block += type;
                        block += ':</div><ul>';
                        malware_scan.result_list[type].forEach(function (item, i, arr) {
                            block += '<li class="' + type.toLowerCase() + ((item.issues) ? " danger" : '') + '">' + item.found_extended + '</li>';
                            if (item.issues) total++;
                        });
                        block += '</ul></div>';

                    }
                }
                else {
                    block = '<div class="result_block">' +
                        '<ul>';
                    block += '<li>' + lang.l_no_issues + '</li>';
                    block += '</ul></div>';
                }
                $this.page.malware_list.append(block);
                $this.page.malware_list_count.html(total);
                $this.page.malware_list.removeClass('d-none');
                $this.page.scanner_report.removeClass('d-none');
            } else {
                showDisclaimerBlock($this.page.malware_list)
                .showDisclaimerBlock($this.page.scanner_report);
            }

            if (typeof malware_scan.links == "object" && malware_scan.links && $('#result_links div.result_block').length === 0) {

                total = 0;
                block = '<div class="result_block">' +
                    '<div class="external_list">';
                block += '<ul>';
                if (typeof malware_scan.links.external == "object" && malware_scan.links.external.length > 0) {
                    malware_scan.links.external.forEach(function (item, i, arr) {
                        block += '<li>' +
                            '<a href="' + url_lang_prefix + '/website-malware-scanner?url=' + item.href + '" ' +
                            'data-href="' + item.href + '">' + item.href + '</a>' +
                            ((item.num > 1) ? '&nbsp;(' + item.num + ')' : '') +
                            ((item.nofollow) ? '&nbsp;<div style="display: inline">(link is "nofollow")</div>' : '') +
                            ' <a href="' + item.href + '" target="_blank" title="Open the link in a new tab." rel="nofollow">' +
                            '<span class="fa fa-external-link"></span>' +
                            '</a>' +
                            '</li>';
                        total ++;
                    });
                }
                else {
                    block += '<li>' + lang.l_no_links + '</li>';
                }
                block += '</ul></div>';

                $this.page.external_links_title.after(block);
                $this.page.external_links_count.html(total);
                $this.page.result_links.removeClass('d-none');
                $this.page.external_links_title.removeClass('d-none');
                $this.page.scanner_report.removeClass('d-none');


                total = 0;
                block = '<div class="result_block" style="display: none">' +
                    '<div class="internal_list" id="internal_list">';
                block += '<ul>';

                if (typeof malware_scan.links.internal == "object" && malware_scan.links.internal.length > 0) {

                    malware_scan.links.internal.forEach(function (item, i, arr) {
                        block += '<li>' +
                            '<a class="internal_link" href="' + url_lang_prefix + '/website-malware-scanner?url=' + item.href + '" ';
                        block += 'data-href="' + item.href + '"';
                        if (typeof item.noindex == "object") {
                            block +=  'data-done="1"';
                        }
                        block += '>' + item.href + '</a>';

                        block += ((item.num > 1) ? '&nbsp;(' + item.num + ')' : '') +
                            '&nbsp;<div class="non_indexable_detail">';
                        if (typeof item.noindex == "object" && typeof item.noindex.code == "string") {
                            block += '<span>' + item.noindex.code + '</span> ';
                        }
                        block += ((item.noindexable) ? ('(non-indexable) <div class="hidden noindexable_block">' +
                                ((item.nofollow) ? '<div>link is "nofollow"</div>' : '') +
                                ((item.robots) ? '<div>' + item.robots + '</div>' : '')) : '');
                        if (typeof item.noindex == "object" && typeof item.noindex.noindex != "undefined") {
                            block += '<div>Page have "noindex"</div>';
                        }
                        block += '</div> <a href="' + item.href + '" target="_blank" title="Open the link in a new tab." rel="nofollow">' +
                            '<span class="fa fa-external-link"></span></a>' +
                            '</li>';
                        total ++;
                    });
                }
                else {
                    block += '<li>' + lang.l_no_links + '</li>';
                }

                block += '</ul></div>';
                $this.page.internal_links_title.after(block);
                $this.page.internal_links_count.html(total);
                if (typeof malware_scan.links.all_links_done == "undefined" || malware_scan.links.all_links_done === false) {
                    $this.link_scanner.init($this.public_id);
                }
                $this.page.result_links.removeClass('d-none');
                $this.page.internal_links_title.removeClass('d-none');
                $this.page.scanner_report.removeClass('d-none');
            } else {
                showDisclaimerBlock($this.page.malware_list)
                .showDisclaimerBlock($this.page.result_links)
                .showDisclaimerBlock($this.page.internal_links_title)
                .showDisclaimerBlock($this.page.external_links_title)
                .showDisclaimerBlock($this.page.scanner_report);
            }
        } else {
            showDisclaimerBlock($this.page.malware_list)
            .showDisclaimerBlock($this.page.result_links)
            .showDisclaimerBlock($this.page.internal_links_title)
            .showDisclaimerBlock($this.page.external_links_title)
            .showDisclaimerBlock($this.page.scanner_report);
        }
    }

    $this.drawSSLResult = function () {
        if ($this.page.ssl_info_block.find('.result_block').length === 0) {

            if (typeof $this.scanning_result.ssl_check == "object" &&
                $this.scanning_result.ssl_check.process &&
                typeof $this.scanning_result.ssl_check.result == "object") {

                var message = '';
                message = '<div class="result_block"><ul>';

                var ssl_check = $this.scanning_result.ssl_check.result;

                if (ssl_check.has_ssl === false) {
                    message += '<li class="warning">No SSL found';
                } else {
                    if (ssl_check.expired === true) {
                        message += '<li>SSL expired, valid till ' + ssl_check.valid_to;
                    } else {
                        message += '<li>SSL valid till ' + ssl_check.valid_to;
                    }
                }

                message += '</li>';

                if (typeof ssl_check.http_ans == "string") {
                    var http_class = (typeof ssl_check.http_class) ? ssl_check.http_class : '';
                    message += '<li class="' + http_class + '">' + ssl_check.http_ans + '</li>';
                }

                message += '</ul></div>';

                $this.page.ssl_info_block.append(message);
                $this.page.ssl_info_block.removeClass('d-none');
                $this.page.scanner_report.removeClass('d-none');

            } else {
                showDisclaimerBlock($this.page.ssl_info_block)
                .showDisclaimerBlock($this.page.scanner_report);
            }
        }
    }

    $this.drawPublicSafeListsResult = function () {
        if ($this.page.public_safe_lists.find('div.result_block').length === 0) {
            var block = '';

            if (typeof $this.scanning_result === "object" &&
                typeof $this.scanning_result.public_safe_lists === "object" &&
                $this.scanning_result.public_safe_lists.process &&
                typeof $this.scanning_result.public_safe_lists.result === "object") {

                var publicSafeLists = $this.scanning_result.public_safe_lists.result;
                block = '<div class="result_block"><ul>';

                var preferredKeys = ["cleantalk", "google"];

                preferredKeys.forEach(function(key) {
                    if (publicSafeLists.hasOwnProperty(key)) {
                        var info = publicSafeLists[key];
                        if (typeof info === "object" && typeof info.name === "string") {
                            block += '<li>' + info.name + '</li>';
                        }
                    }
                });

                $.each(publicSafeLists, function(provider, info) {
                    if (preferredKeys.indexOf(provider) === -1) {
                        if (typeof info === "object" && typeof info.name === "string") {
                            block += '<li>' + info.name + '</li>';
                        }
                    }
                });

                block += '</ul></div>';
                $this.page.public_safe_lists.append(block);
                $this.page.scanner_report.removeClass('d-none');
                $this.page.public_safe_lists.removeClass('d-none');
            } else {
                showDisclaimerBlock($this.page.public_safe_lists)
                .showDisclaimerBlock($this.page.scanner_report);
            }
        }
    };

    $this.drawRepositoryScan = function () {
        if ($this.page.result_repository.find('div.result_block').length === 0) {

            var block = '';

            if (typeof $this.scanning_result == "object" &&
                typeof $this.scanning_result.repository_check == "object" &&
                $this.scanning_result.repository_check.process &&
                typeof $this.scanning_result.repository_check.result == "object") {

                var repository_check = $this.scanning_result.repository_check.result;

                var has_warning = false;
                for (key in repository_check) {
                    if (repository_check[key] === true) has_warning = true;
                }

                block = '<div class="result_block"><ul>';
                if (has_warning) {
                    for (key in repository_check) {
                        if (repository_check[key] === true) {
                            block += '<li class="danger">' + lang.repository['l_' + key] + '</li>';
                        }
                    }
                    if (typeof $this.scanning_result.get_url_code == "object" &&
                        typeof $this.scanning_result.get_url_code.target_url == "string") {
                        var url = $this.scanning_result.get_url_code.target_url;
                        if (url.slice(-1) !== '/') url += '/';
                        block = block.replaceAll(':URL:', url);
                    }

                }
                else {
                    block += '<li>' + lang.l_no_issues + '</li>';
                }
                block += '</ul></div>';
                $this.page.result_repository.append(block);
                $this.page.scanner_report.removeClass('d-none');
                $this.page.result_repository.removeClass('d-none');
            } else {
                showDisclaimerBlock($this.page.result_repository)
                .showDisclaimerBlock($this.page.scanner_report);
            }
        }
    }

    $this.drawCMSRecognize = function () {
        if ($this.page.result_recognize_cms.find('div.result_block').length === 0) {

            var block = '';

            if (typeof $this.scanning_result == "object" &&
                typeof $this.scanning_result.cms_recognize == "object" &&
                $this.scanning_result.cms_recognize.process &&
                typeof $this.scanning_result.cms_recognize.result == "string") {

                var cms_recognize = $this.scanning_result.cms_recognize.result;

                block = '<div class="result_block"><ul>';
                block += '<li>' + cms_recognize + '</li>';
                block += '</ul></div>';
                $this.page.result_recognize_cms.append(block);
                $this.page.scanner_report.removeClass('d-none');
                $this.page.result_recognize_cms.removeClass('d-none');
            } else {
                showDisclaimerBlock($this.page.result_recognize_cms)
                .showDisclaimerBlock($this.page.scanner_report);
            }
        }
    }

    $this.formatStepLink = function () {
        $('.scanning_step').each(function () {
            var href = '';
            switch ($(this).data('step-link')) {
                case 'get_url_code':
                    if (!$this.page.page_info_block.hasClass('d-none')) {
                        href = 'page_info_link';
                    }
                    break;
                case 'public_safe_lists':
                    if (!$this.page.public_safe_lists.hasClass('d-none')) {
                        href = 'public_safe_lists_link';
                    }
                    break;
                case 'malware_scan':
                    if (!$this.page.malware_list.hasClass('d-none')) {
                        href = 'malware_scan_link';
                    }
                    break;
                case 'external-links':
                    if (!$this.page.external_links_title.hasClass('d-none')) {
                        href = 'external-links_link';
                    }
                    break;
                case 'internal-links':
                    if (!$this.page.internal_links_title.hasClass('d-none')) {
                        href = 'internal-links_link';
                    }
                    break;
                case 'ssl_check':
                    if (!$this.page.ssl_info_block.hasClass('d-none')) {
                        href = 'ssl_info_link';
                    }
                    break;
                case 'repository_check':
                    if (!$this.page.result_repository.hasClass('d-none')) {
                        href = 'repository_check_link';
                    }
                    break;
                case 'cms_recognize':
                    if (!$this.page.result_recognize_cms.hasClass('d-none')) {
                        href = 'result_recognize_cms_link';
                    }
                    break;
            }
            if (href !== '' && $('a[href="' + href + '"]').length === 0) {
                $(this).wrap('<a href="#' + href + '"></a>');
            }
        });
    }

    $this.checkProgress = function () {
        var total = 1;
        var finished = 0;
        for (var key in $this.scanning_result) {
            if (['title', 'end_scanning'].indexOf(key) < 0 ) {
                total ++;
                if ($this.scanning_result[key].process) finished ++;
            }
        }
        finished += ($this.link_scanner_progress / 100);
        var percent = (total > 0) ? (finished / total * 100) : 0;
        $this.setProgressBar(percent);
        if (percent >= 100 ||
            ($this.scanning_result.end_scanning &&
                ($this.link_scanner_progress >= 100 || $this.link_scanner_progress === 0))) {
            $this.drawTitle();
            $this.ScanDone();
        }
    }

    $this.setProgressBar = function (percent) {
        if (percent < 0) percent = 0;
        if (percent > 100) percent = 100;
        percent = Math.ceil(percent);
        $this.page.progressbar.find('div.progress-bar')
            .css('width', percent + '%')
            .attr('aria-valuenow', percent)
            .html(percent + '%');
    }

    $this.getSteps = function () {
        if ($.isEmptyObject($this.scanner_steps) && typeof $this.scanning_result != "undefined") {
            for (key in $this.scanning_result) {
                if (['title', 'end_scanning'].indexOf(key) < 0 ) {
                    $this.scanner_steps[$this.scanning_result[key].order] = key;
                }
            }
        }
    }

    $this.setCurrentStep = function () {
        $this.getSteps();
        if ($.isEmptyObject($this.scanner_steps)) {
            return false;
        }
        var current_step = '';
        var internal_checks = false;
        var has_step = false;
        for (step in $this.scanner_steps) {
            internal_checks = $this.scanning_result['malware_scan'].process === true && $this.link_scanner_progress < 100;
            if ($this.scanning_result[$this.scanner_steps[step]].process === false && !has_step) {
                has_step = true;
                current_step = $this.scanner_steps[step];
                $('.scanning_step').removeClass('current_step');
                $('.scanning_step[data-step="' + current_step + '"]').addClass('current_step');
            }
            if ($this.scanning_result[$this.scanner_steps[step]].process === true) {
                $('.scanning_step[data-step="' + $this.scanner_steps[step] + '"]').find('span.step_percent').html('(100%)');
            }
        }
        if (!has_step) {
            $('.scanning_step').removeClass('current_step');
        }
        if (internal_checks) {
            $('.scanning_step[data-step="scan_internal_links"]').addClass('current_step').find('span.step_percent').html('(' + $this.link_scanner_progress + '%)');
        }
    }

    $this.setEndLinkCheck = function () {
        var sent_data = new FormData();
        sent_data.append('action', 'set_end_link_scanning');
        sent_data.append('public_id', $this.public_id);
        sent_data.append('public_result', $('#public_result').is(':checked') ? 'on' : 'off');
        $.ajax({
            url: window.location.pathname,
            type: 'POST',
            processData: false,
            contentType: false,
            data: sent_data,
            error: function (data) {
                console.log(data);
            },
        });
    }

    $this.formatRegisterForm = function () {
        if (typeof $this.scanning_result == "object" &&
            typeof $this.scanning_result.title == "object" &&
            typeof $this.scanning_result.title.style == "string" &&
            $this.register_form.title.length > 0 && $this.register_form.button.length > 0) {
            if ($this.scanning_result.title.style === "success") {
                $this.register_form.title.html(lang.l_register_title);
                $this.register_form.button.html(lang.l_register_button);
            }
            else {
                $this.register_form.title.html(lang.l_register_title_malware);
                $this.register_form.button.html(lang.l_register_button_malware);
            }
        }
    }

    $this.drawJSIframes = function () {
        var jsIframesBlock = $('#js_iframes_block');
        var jsIframes = $('#js_iframes');

        if (jsIframesBlock.length === 0 || jsIframes.length === 0) {
            return;
        }

        if (!$this.scanning_result.js_iframes ||
            !$this.scanning_result.js_iframes.result) {
            jsIframesBlock.html('<p>' + lang.l_no_external_scripts + '</p>');
            jsIframes.removeClass('d-none');
            return;
        }  else {
            showDisclaimerBlock(jsIframes);
        }

        var jsData = $this.scanning_result.js_iframes.result;
        var scriptList = '';
        var iframeList = '';

        if (jsData.scripts && jsData.scripts.length > 0) {
            jsData.scripts.forEach(function (src) {
                var escapedSrc = src.replace(/'/g, "\\'");
                scriptList += '<li class="js_iframes_item">' +
                            src +
                            ' <a href="javascript:void(0);" onclick="return confirmExternalNavigation(\'' + escapedSrc + '\');" title="'+ lang.l_open_script_new_tab + '" rel="nofollow">' +
                            '<span class="fa fa-external-link"></span>' +
                            '</a>' +
                            '</li>';
            });
        }

        if (jsData.iframes && jsData.iframes.length > 0) {
            jsData.iframes.forEach(function (src) {
                var escapedSrc = src.replace(/'/g, "\\'");
                iframeList += '<li class="js_iframes_item">' +
                            src +
                            ' <a href="javascript:void(0);" onclick="return confirmExternalNavigation(\'' + escapedSrc + '\');" title="'+ lang.l_open_iframe_new_tab + '" rel="nofollow">' +
                            '<span class="fa fa-external-link"></span>' +
                            '</a>' +
                            '</li>';
            });
        }

        var html = '';
        if (scriptList !== '') {
            html += '<h4>' + lang.l_scripts + '</h4>' +
                    '<ul class="js_iframes_list">' + scriptList + '</ul>';
        }
        if (iframeList !== '') {
            if (scriptList !== '') {
                html += '<br>';
            }
            html += '<h4>' + lang.l_iframes + '</h4>' +
                    '<ul class="js_iframes_list">' + iframeList + '</ul>';
        }

        if (html !== '') {
            jsIframesBlock.html(html);
        } else {
            jsIframesBlock.html('<p>' + lang.l_no_external_scripts + '</p>');
        }

        jsIframes.removeClass('d-none');
    };

    window.confirmExternalNavigation = function(url) {
        if (confirm(lang.l_external_navigation + url + '\n\n' +  lang.l_warning_external_navigation)) {
            window.open(url, '_blank');
        }
        return false;
    };

    $this.init();
}

function getClosestParentByAttribute(element, attribute) {
    return element.closest(attribute);
}

function findNeighborByAttribute(element, attribute) {
    var parent = element.parentElement;

    if (!parent) return null;

    return parent.querySelector(attribute);
}

function getChildByAttribute(element, attribute) {
    return element.querySelector(attribute);
}

function findNeighboringElement(element, attribute) {
    return (
        element.closest(attribute) ||
        getPreviousSiblingByAttribute(element, attribute) ||
        getNextSiblingByAttribute(element, attribute) ||
        getChildByAttribute(element, attribute)
    );
}

function showDisclaimerBlock(element) {
    element.removeClass('d-none');

    var neighbor = findNeighborByAttribute(element[0], '.scanning__disclaimer');

    if(neighbor && neighbor.classList) {
        neighbor.classList.remove('scanning__disclaimer');
        neighbor.classList.add('result_block');
    }

    return this
}
